module.exports = __webpack_public_path__ + "static/img/valueadd19.86c8c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd19.png
// module id = ZKPD
// module chunks = 1